<template>
  <form v-if="warehouses" class="space-y-6 w-full bg-white dark:bg-gray-750 p-4 rounded-lg">

    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div class="col-span-1 md:col-span-2">
        <h2 class="text-xl font-bold dark:text-gray-300">Noliktava</h2>
      </div>

      <div class="col-span-1">
        <Select v-model="form.senderWarehouse" :errors="errors.senderWarehouse" :items="warehouses" placeholder="No" @change="clearItems" />
      </div>

      <div class="col-span-1">
        <Select v-model="form.receiverWarehouse" :errors="errors.receiverWarehouse" :items="warehouses" placeholder="Uz" @change="clearItems" />
      </div>
    </div>

    <template v-if="form.senderWarehouse && form.senderWarehouse.id">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div class="col-span-1 md:col-span-2">
          <h2 class="text-xl font-bold dark:text-gray-300">Preces</h2>
        </div>

        <template v-for="(item, index) in stockBalanceItems" :key="index">
          <div class="col-span-1 md:col-span-2">
            <SingleStockMovementItemForm :item="item" @item="(value) => setItem(value, index)" @remove-product="removeOrderItem(index)" />
          </div>
        </template>

        <div class="col-span-1">
          <Autocomplete placeholder="Prece" url="/api/fetch_catalog_items" @autocompleteItem="getCatalogItem" :params="{warehouse_id: form.senderWarehouse.id}" :additionalFields="['sku']" :clearOnClick="true" />
        </div>
      </div>
    </template>

    <div class="pt-5">
      <div class="flex justify-end">
        <button @click="goBack" type="button" class="bg-white dark:bg-gray-750 py-2 px-4 border border-gray-300 dark:border-gray-500 rounded-md shadow-sm text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-770 focus:outline-none focus:ring-0 mr-2">
          Atcelt
        </button>

        <template v-if="stockBalanceItems.length > 0 && displaySubmitButton">
          <template v-if="!loading">
            <button type="button" class="flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-gradient-to-r from-button2-from to-button2-to hover:from-button2-to hover:to-button2-from focus:outline-none focus:border-none transition duration-500 ease-in-out" @click.prevent="submit">
              Pievienot
            </button>
          </template>
          <template v-else>
            <Loading />
          </template>
        </template>
      </div>
    </div>

  </form>
</template>

<script>
import { mapGetters } from "vuex";

import Autocomplete from "@/components/Components/Autocomplete";
import Select from "@/components/Components/Select";
import Loading from "@/components/Components/Loading";
import Validation from "@/modules/Validation";
import SingleStockMovementItemForm from "@/components/Stock/TehnicalDocuments/TehnicalDocumentsForms/SingleStockMovementItemForm"

export default {
  name: "CreateStockBalance",
  components: {
    Autocomplete,
    Select,
    Loading,
    SingleStockMovementItemForm,
  },
  data: () => ({
    form: {
      senderWarehouse: null,
      receiverWarehouse: null,
    },
    catalogItem: null,
    stockBalanceItems: [],
  }),
  created() {
    this.$store.dispatch('getWarehousesList')
  },
  computed: {
    ...mapGetters({
      loading: "loading",
      warehouses: "warehousesList",
      errors: "errors"
    }),
    displaySubmitButton(){
      const itemsWithoutQuantity = this.stockBalanceItems.filter(item  => {
        return item.quantity === '' || item.quantity === null
      })
      if(itemsWithoutQuantity.length > 0) {
        return false
      }
      const itemsWithError = this.stockBalanceItems.filter(item  => {
        return item.errorMessage !== ''
      })
      return itemsWithError.length <= 0;
    }
  },
  watch: {
    catalogItem() {
      if(this.catalogItem) {
        this.addCatalogItemToStockBalanceItemsList()
        this.catalogItem = null
      }
    }
  },
  methods: {
    setItem(value, index) {
      this.stockBalanceItems[index] = value
    },
    setStockBalanceItemErrors() {
      this.formValidation = {}
      this.stockBalanceItems.map((item) => {
        this.formValidation[`quantity-${item.id}`] = {rules: ['required']};
      })
    },
    getStockBalanceItemsValidationValues() {
      this.setStockBalanceItemErrors()
      let form = {}
      form = this.form
      this.stockBalanceItems.map((item) => {
        form[`quantity-${item.id}`] = item.quantity
      })

      return form
    },
    clearItems(){
      this.stockBalanceItems = []
    },
    getCatalogItem(value) {
      this.catalogItem = value
    },
    addCatalogItemTostockBalanceItems() {
      this.catalogItem.quantity = null
      this.catalogItem.errorMessage = ''

      this.stockBalanceItems.push(this.catalogItem)
    },
    addCatalogItemToStockBalanceItemsList() {
      const componentExists = this.stockBalanceItems.some( component => {
        return component.id === this.catalogItem.id
      })
      if(!componentExists) {
        this.addCatalogItemTostockBalanceItems()
      }
    },
    removeOrderItem(index) {
      this.stockBalanceItems.splice(index, 1);
    },
    formatstockBalanceItems() {
      return this.stockBalanceItems.map( orderItem => {
        return {
          catalog_item_id: orderItem.id,
          quantity: orderItem.quantity,
        }
      })
    },
    goBack() {
      if (confirm("Vai esi drošs? Visi ievadītie lauki tiks pazaudēti")) {
          this.$router.go(-1);
      }
    },
    submit() {
      this.$Progress.start();
      const form = this.getStockBalanceItemsValidationValues()
      if (Validation(this.formValidation, form)) {
        this.$store.dispatch('storeStockMovement', {
          sender_id: this.form.senderWarehouse.id,
          receiver_id: this.form.receiverWarehouse.id,
          items : this.formatstockBalanceItems()
        })
      } else this.$Progress.fail();
    },
  },
};
</script>

<style>

</style>